import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseDataBody } from 'src/types/websocket'

const initialState: ResponseDataBody.StorageInfo = {
  ExternalInfo: {
    Now: null,
    Max: null,
    Exist: false,
  },
  InternalInfo: {
    Now: null,
    Max: null,
  },
}

const storageInfoSlice = createSlice({
  name: 'storageInfo',
  initialState,
  reducers: {
    setStorageInfo(state, action: PayloadAction<ResponseDataBody.StorageInfo>) {
      const {
        ExternalInfo: { Now: externalNow, Max: externalMax, Exist },
        InternalInfo: { Now: internalNow, Max: internalMax },
      } = action.payload
      state.ExternalInfo.Exist = Exist
      state.ExternalInfo.Now = externalNow
      state.ExternalInfo.Max = externalMax
      state.InternalInfo.Now = internalNow
      state.InternalInfo.Max = internalMax
    },
  },
})

export const { setStorageInfo } = storageInfoSlice.actions

export default storageInfoSlice.reducer
